module.exports = __webpack_public_path__ + "static/media/Imagen 108@2x.1790aea2.png";